import { initializeApp, getApp, getApps, FirebaseApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';

export const auth: () => Auth = () => {
    const apps = getApps();
    let app: FirebaseApp;
    if (!apps.length) {
        app = initializeApp({
            apiKey: import.meta.env.GOOGLE_API_KEY,
            authDomain: import.meta.env.CONSOLE_FIREBASE_AUTH_DOMAIN,
            databaseURL: import.meta.env.CONSOLE_FIREBASE_DATABASE_URL,
            projectId: import.meta.env.CONSOLE_FIREBASE_PROJECT_ID,
            storageBucket: import.meta.env.CONSOLE_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: import.meta.env.CONSOLE_FIREBASE_MESSAGING_SENDER_ID
        });
    } else {
        app = getApp();
    }
    return getAuth(app);
};
